<template>
  <div class="resetPassword">
    <div class="login-content">
      <div class="login-box">
        <div class="reset-pass-header mb10">修改密码</div>
        <el-alert title="" type="warning">
          <div class="importantNote"> 
            <i class="iconfont icon-kaiqi f16 col_FEAF0D mr5"></i>
            <span class="col_orange">您的密码过于简单，为了您的账号安全，建议设置新密码！</span>
          </div>
        </el-alert>
        <div class="reset-pass-form" v-if="step !== 3">
          <el-form ref="resetPass" :rules="rule" :model="resetPass">
            <el-form-item label="设置新密码" prop="password" :key="1">
              <el-input
                type="password"
                v-model="resetPass.password"
                placeholder="请输入新密码"
              ></el-input>
              <ots-password-tooltip></ots-password-tooltip>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword" :key="2">
              <el-input
                type="password"
                v-model="resetPass.confirmPassword"
                placeholder="请再次输入新密码"
              ></el-input>
            </el-form-item>
            <div class="nextBorder">
              <div class="next active cp" @click="rightEditPsd('resetPass')">
                确认修改
              </div>
              <div class="next active cp" @click="goNext">
                暂不修改
              </div>
            </div>

          </el-form>
        </div> 
        <div class="reset-finsh" v-else>
          <div class="reset-success-icon">
            <img src="../../../assets/stuImg/reset-pass-success-icon.png" alt="">
          </div>
          <div class="reset-success-text">密码修改成功</div>
          <div class="auto-go-login">
            {{pushTime}}s后自动跳转首页，或<span @click="goNext">直接跳转</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPwd, passWordStrength } from "@/common/verify.js";
export default {
  name: "updatePassword",
  data() {
    return {
      step: 1,
      pushTime: 5,
      resetPass: {
        tenant: window.localStorage.getItem('tenant'),
        password: "",
        confirmPassword: "",
      },
      rule: {
        password: [
          { required: true, message: "请输入设置密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  mounted () {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo')) 
  },
  methods: {
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPass.password !== this.resetPass.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback()
        }
      }
      callback()
    },
    rightEditPsd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {password, confirmPassword, tenant } = this.resetPass
          let userId = this.userInfo.id
          this.$api.login
            .editPsd({ userId, password, confirmPassword, tenant })
            .then((res) => {
              if (res.code) {
                this.$message.success('密码修改成功')
                this.step = 3
                this.pushTime = 5
                this.timer = setInterval(() => {
                  if (this.pushTime === 0) {
                    clearInterval(this.timer)
                    this.goNext()
                  }
                  this.pushTime--
                }, 1000)
              }
            })
        } else {
          console.log("error submit!!");
          return false
        }
      });
    },
    goNext () {
      this.$router.push({ name: "home"})
    }
  },
};
</script>


<style lang="less" scoped>
.resetPassword {
  background: rgba(255, 255, 255, 0.95);
  width: 100%;
  height: 500px;
  padding: 32px 48px 40px 48px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  /* IE 兼容 */
  height: auto\0;
  padding-bottom: 130px\0;
  .reset-pass-header {
    color: #333;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 16px;
    border-bottom: 1px solid #eeeeee;
  }
  .reset-pass-step-box {
    margin-top: 20px;
    height: 46px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    .step-item.active {
      .step-item-num {
        background-color: #006aff;
        color: #fff;
      }
      .step-item-name {
        color: #006aff;
      }
    }
    .step-item {
      display: flex;
      align-items: center;
      .step-item-num {
        width: 28px;
        height: 28px;
        background-color: #d8d8d8;
        color: #fff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
      }
      .step-item-name {
        margin-left: 14px;
        color: #666666;
        font-size: 13px;
        font-weight: bold;
      }
    }
    .step-division.active {
      .step-division__ {
        background-color: #006aff;
      }
    }
    .step-division {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      .step-division__ {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #d5d5d5;
      }
      .step-division__:nth-child(2) {
        margin: 0 8px;
      }
    }
  }
  .reset-pass-form {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .nextBorder{
      display: flex;
      justify-content: space-around;
    }
    .next.active {
      background: #006aff;
    }
    .next {
      width: 160px;
      height: 40px;
      background: #d5d5d5;
      border-radius: 100px;
      color: #fff;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
    .code-form {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code-time {
        width: 100px;
        height: 38px;
        background: #fff;
        color: #006aff;
        border: 1px solid #006aff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .get-code-btn {
        cursor: pointer;
        width: 102px;
        height: 38px;
        border: 1px solid #d5d5d5;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin-top: 2px;
      }
      .get-code-btn.active {
        border: 1px solid #006aff;
        color: #006aff;
      }
    }
    .el-form-item {
      margin-bottom: 24px !important;
      /deep/ .el-form-item__label {
        line-height: 1;
        margin-bottom: 8px;
      }
      /deep/ .el-input {
        width: 100%;
      }
      /deep/ .el-input__inner {
        width: 360px;
        box-sizing: border-box;
        height: 40px;
      }
    }
  }
  .reset-finsh {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .reset-success-icon {
      margin-bottom: 14px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .reset-success-text {
      color: #08bd6b;
      font-size: 24px;
      font-weight: bold;
    }
    .auto-go-login {
      margin-top: 12px;
      color: #9299a6;
      font-size: 16px;
      span {
        color: #006aff;
        cursor: pointer;
      }
    }
  }
}
.el-alert {
  margin-bottom: 24px;
  background: #fff5e0;
  border: 1px solid #ffd970;
  height: 48px;
  line-height: 48px;
  box-sizing: border-box;
  .importantNote {
    font-size: 14px;
    color: #45494d;
    margin-left: -10px;
    margin-top: -7px;
  }
  /deep/ .el-alert__closebtn {
    top: 17px;
    color: #ff9500;
  }
}

/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
/deep/ .el-form{
  width:360px\0;
}
</style>